import { injectable } from 'inversify';

import { HttpService } from '@vk-hr-tek/core/http';
import { DeepPartial, Tokens } from '@vk-hr-tek/ui/Theme';

@injectable()
export class AppService {
  constructor(private http: HttpService) {}

  async getDesignTokens() {
    const result = await this.http.get('/theme', undefined, {
      withAuth: false,
    });

    return result as DeepPartial<Tokens>;
  }
}
